<template>
  <div class="filters-box-row">
		<div class="filters-container">
			<div class="input-box">
				<span>商品名称：</span>
				<el-input
					v-model="goodsName"
					placeholder="请输入商品名称"
					class="filter-input"
					size="small"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<div class="input-box">
				<span>可售状态：</span>
				<el-select v-model="saleState" class="filter-input" size='small'>
					<el-option value="2" label="全部"></el-option>
					<el-option value="1" label="可售"></el-option>
					<el-option value="0" label="不可售"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>店铺级大类：</span>
				<el-select v-model="bcId" class="filter-input" size='small' @change="bcChange">
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in bc">
						<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
					</template>
				</el-select>
			</div>
			<el-button size="small" type="primary" class="btn" @click="search">查询</el-button>
			<el-button size="small" plain class="btn" @click="clear">清空</el-button>
			<el-button size="small" type="text" class="btn" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
			</el-button>
		</div>
		<div class="filters-container" v-if="!collapse">
			<div class="input-box" v-if="bigcategoryview === 1">
				<span>店铺级小类：</span>
				<el-select v-model="scId" class="filter-input" size='small'>
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in sc">
						<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
					</template>
				</el-select>
			</div>
			<div class="input-box" v-if="auditStateShow !== 0">
				<span>审核状态：</span>
				<el-select v-model="auditState" class="filter-input" size='small'>
					<el-option value="4" label="全部"></el-option>
					<el-option value="0" label="待提交"></el-option>
					<el-option value="1" label="待审核"></el-option>
					<el-option value="2" label="已通过"></el-option>
					<el-option value="3" label="驳回"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>商品来源：</span>
				<el-select v-model="sourceflag" class="filter-input" size='small'>
					<el-option value="-1" label="全部"></el-option>
					<el-option value="1" label="云供应链"></el-option>
					<el-option value="0" label="新建"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>计量单位：</span>
				<el-select v-model="unitFlag" class="filter-input" size='small'>
					<el-option value="-1" label="全部"></el-option>
					<el-option value="1" label="有"></el-option>
					<el-option value="0" label="无"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>私密状态：</span>
				<el-select v-model="hiddenFlag" class="filter-input" size='small'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="0" label="公开"></el-option>
					<el-option :value="1" label="私密"></el-option>
				</el-select>
			</div>
		</div>
  </div>
</template>

<script>
export default {
	name: 'search',
	props: {
		auditStateShow: {
			type: Number
		}
	},
	data () {
		return {
			hiddenFlag: -1,
			goodsName: '',
			bcId: '0',
			scId: '0',
			saleState: '2',
			sourceflag: '-1',
			unitFlag: '-1',
			auditState: '4',
			collapse: false,
			bc: [],
			sc: [],
			bigcategoryview: 0
		}
	},
	created () {
		this.checkSmallCategory().then(res => {
			this.getBigCategory()
			this.bigcategoryview = res.bigcategoryview
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		})
		let a = window.sessionStorage.getItem('goodsInfo')
		if (a) {
			let b = JSON.parse(a)
			this.goodsName = b.goodsName + ''
			this.bcId = b.bcId + ''
			this.scId = b.scId + ''
			this.saleState = b.saleState + ''
			this.auditState = b.auditState + ''
			this.sourceflag = b.sourceflag + ''
			this.unitFlag = b.unitFlag + ''
			this.hiddenFlag = +b.hiddenFlag
			this.searchEvent()
		}
	},
	methods: {
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		search () {
			let goodsInfoStr = window.sessionStorage.getItem('goodsInfo')
			if (goodsInfoStr) {
				let goodsInfo = JSON.parse(goodsInfoStr)
				goodsInfo.scrollTopValue = 0
				goodsInfo.page = 1
				window.sessionStorage.setItem('goodsInfo', JSON.stringify(goodsInfo))
			}
			this.$emit('initPage')
			this.searchEvent()
		},
		searchEvent () {
			this.$emit('handleSearch', { goodsName: this.goodsName, bcId: this.bcId, scId: this.scId, saleState: this.saleState, auditState: this.auditState, sourceflag: this.sourceflag, unitFlag: this.unitFlag, hiddenFlag: this.hiddenFlag })
		},
		clear () {
			this.goodsName = ''
			this.bcId = '0'
			this.scId = '0'
			this.saleState = '2'
			this.auditState = '4'
			this.sourceflag = '-1'
			this.unitFlag = '-1'
			this.hiddenFlag = -1
			this.search()
		},
		bcChange (value) {
			this.bcId = '' + value
			this.scId = '0'
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	flex-direction column
	padding: 10px 0;
	width :100%;
	line-height :60px;
	min-width :600px;
	box-sizing: border-box
	.filters-container {
		display flex
		flex: 1
		height: 60px
		.input-box {
			display flex
			width: 250px
			margin-left: 20px
			span {
				margin-right: 10px
			}
			.filter-input {
				flex: 1
			}
		}
		.btn {
			height: 32px
			margin-top: 14px
			margin-left 20px
		}
	}
}
</style>
